import { AxiosResponse } from 'axios';
import { useIsFetching, useQuery, UseQueryResult } from 'react-query';
import { StaffAvailability, type StaffAvailabilityCalendarEvent, UrlParams } from 'types';
import { client } from 'utils/api-client';

interface UseStaffAvailabilityCalendarProps {
  startDate: string | null;
  endDate: string | null;
  coaches: string[] | null;
  enabled?: boolean;
}

const QUERY_KEY_NAME = 'staff-availability-calendar';

export default function useStaffAvailabilityCalendar({
  startDate,
  endDate,
  coaches,
  enabled = true,
}: UseStaffAvailabilityCalendarProps): UseQueryResult<{
  data: StaffAvailabilityCalendarEvent[];
}> {
  const queryFn = (): Promise<AxiosResponse<StaffAvailability[]>> => {
    const params: UrlParams = {};

    if (coaches && !!coaches.length) {
      params.coaches = coaches.filter(c => c !== 'None').join(',');
    }
    if (startDate) {
      params.start_date = startDate;
    }
    if (endDate) {
      params.end_date = endDate;
    }

    return client.get(`staff-availability/calendar/`, {
      params,
    });
  };

  return useQuery([QUERY_KEY_NAME, coaches, startDate, endDate, enabled], queryFn, {
    enabled,
  });
}

export function useStaffAvailabilityCalendarIsFetching(): boolean {
  return !!useIsFetching({
    queryKey: [QUERY_KEY_NAME],
  });
}
